import { Box, Typography } from "@mui/material";
import React from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";

const ProgressDisplay = ({
  content
}) => {
  return (
    <CommonCard
      borderRadius={2}
      paddingBottom="0px"
      marginTop="0px"
      content={
        <Box display="flex" gap={4} alignItems="center" justifyContent="center">
          {content}
        </Box>
      }
    />
  )
}

const ProgrssBar = ({
    progressData,
}) => {
    return (
        <Box display="flex" gap={1} width={'50%'}>
            <ProgressDisplay
              content={
                <Box textAlign="center">
                  <Typography fontSize={22} color={theme.palette.secondary.main} fontWeight={600}>{progressData?.assignments_avg}%</Typography>
                  <Typography fontSize={14} color={theme.palette.background.dark}>Assignment</Typography>
                </Box>
              }
            />
            <ProgressDisplay
              content={
                <Box textAlign="center">
                  <Typography fontSize={22} color='#10AE2D' fontWeight={600}>{progressData?.tests_avg}%</Typography>
                  <Typography fontSize={14} color={theme.palette.background.dark}>Tests</Typography>
                </Box>
              }
            />
            <ProgressDisplay
              content={
                <Box textAlign="center">
                  <Typography fontSize={22} color={theme.palette.primary.main} fontWeight={600}>{progressData?.quizzes_avg}%</Typography>
                  <Typography fontSize={14} color={theme.palette.background.dark}>Quizzes</Typography>
                </Box>
              }
            />
          </Box>
    )
}

export default ProgrssBar;